import {
    CSSProperties,
    FC,
    memo,
    ReactElement,
} from 'react';

import { randomInBetweenValue } from '../../helpers/number';

import './Skeleton.scss';

interface SkeletonProps {
    className?: string;
}

export const Skeleton: FC<SkeletonProps> = memo(({
    className = '',
}): ReactElement => {
    const cssVariables = {
        '--skeleton-width': `${randomInBetweenValue(45, 95)}%`,
    } as CSSProperties;

    return (
        <span style={cssVariables} className={`skeleton ${className}`} />
    );
});
